module.exports = __webpack_public_path__ + "media/images/flags/mz-4e2241e27dfd0cff1c0e69011d8f66a1.svg";